export const contactsData = {
    email: 'artagaomar@gmail.com',
    phone: '+52 353 535 6342',
    phoneRaw: '+523535356342',   // For tel: and WhatsApp links (no spaces/dashes)
    whatsapp: 'https://wa.me/523535356342',
    address: 'XXJP+G8P, Sin Nombre, Tenería, 59500 San José de Gracia, Mich.',
    mapsLink: 'https://www.google.com/maps/search/?api=1&query=Cremer%C3%ADa%20Limas%2C%20XXJP%2BG8P%2C%20Sin%20Nombre%2C%20Tener%C3%ADa%2C%2059500%20San%20Jos%C3%A9%20de%20Gracia%2C%20Mich.%2C%20Mexico',
}